module.exports = __webpack_public_path__ + "img/egressos-modelo3.b7c68702.png";